import { render, staticRenderFns } from "./ActionItemDetail.vue?vue&type=template&id=0e50ebca&scoped=true"
import script from "./ActionItemDetail.vue?vue&type=script&lang=js"
export * from "./ActionItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ActionItemDetail.vue?vue&type=style&index=0&id=0e50ebca&prod&lang=scss&scoped=true"
import style1 from "./ActionItemDetail.vue?vue&type=style&index=1&id=0e50ebca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50ebca",
  null
  
)

export default component.exports